import { useBasicAppraiser } from "../../hooks/api.hooks";
import { useRouteQuery } from "../../hooks/router.hooks";
import { LoaderCentered } from "../loaders/LoaderCentered";
import { CenteredContentWrapper } from "../wrappers/CenteredContentWrapper";

export const LeadEnabledCheck = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const appraiserId = useRouteQuery().get("appraiserId");

  const { data: basicData, isLoading } = useBasicAppraiser(appraiserId);

  const { organization } = basicData ?? {};

  if (isLoading) {
    return <LoaderCentered />;
  }

  if (!appraiserId) {
    return <div>Klaida</div>;
  }

  if (!organization?.leadFlowEnabled) {
    return (
      <CenteredContentWrapper style={{ marginTop: "50px" }}>
        Vertinimo užklausos šioje organizacijoje neaktyvios
      </CenteredContentWrapper>
    );
  }

  return <>{children}</>;
};
